const editConnecta = {
  state: () => ({
    profile: {
      user_id: -1,

      job: '',
      job_grade: '',
      schedule: '',
      description: '',
      skills: [],
      languages: [],
      educations: [],
    },
  }),
  mutations: {
    updateConnectaProfile(state, payload) {
      state.profile = payload;
    },
    addEducationConnectaProfile(state, payload) {
      state.profile.educations.unshift(payload);
    },
    updateEducationConnectaProfile(state, payload) {
      const index = state.profile.educations.findIndex((education) => education.id === payload.id);

      if (index !== -1) {
        state.profile.educations[index] = payload;
        state.profile.educations = [...state.profile.educations];
      }
    },
  },
  actions: {
    updateConnectaProfile(context, payload) {
      context.commit('updateConnectaProfile', payload);
    },
    addEducationConnectaProfile(context, payload) {
      context.commit('addEducationConnectaProfile', payload);
    },
    updateEducationConnectaProfile(context, payload) {
      context.commit('updateEducationConnectaProfile', payload);
    },
  },
};

export default editConnecta;
